import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getGroup = groupId =>
  call(websocketFetch, 'get_group', { group_id: groupId });
